import type { ProductVM } from "../mappers";
import { DASH } from "../format";
import { C } from "../theme";

/** "13 · Consulta efectiva" in teal, anything else (e.g. "09") in amber. */
export const ProductPill = ({ product }: { product: ProductVM }) => {
  const ok = product.tone === "ok";
  const text = [product.code, product.desc].filter((x) => x !== DASH).join(" · ");
  return (
    <span
      style={{
        fontSize: 12,
        fontWeight: 700,
        color: ok ? C.onOk : C.onWarn,
        background: ok ? C.ok : C.warn,
        borderRadius: 999,
        padding: "3px 10px",
        whiteSpace: "nowrap",
      }}
    >
      {text || DASH}
    </span>
  );
};
